import Swiper, {EffectFade, Navigation} from 'swiper';

class WheelCarousel {
  constructor(element) {
    this.element = element;
    this.sliderImage = this.element.querySelector('[data-element="slider-image"]');
    this.sliderContent = this.element.querySelector('[data-element="slider-content"]');
    this.nextButton = this.element.querySelector('[data-element="next"]');
    this.prevButton = this.element.querySelector('[data-element="prev"]');
  }

  init() {
    this.initSwiper();
  }

  initSwiper() {
    new Swiper(this.sliderImage, {
      allowTouchMove: false,
      effect: 'fade',
      loop: true,
      modules: [EffectFade, Navigation],
      mousewheel: true,
      navigation: {
        nextEl: this.nextButton,
        prevEl: this.prevButton,
      },
      slidesPerView: 1,
      spaceBetween: 0,
    });

    new Swiper(this.sliderContent, {
      allowTouchMove: false,
      effect: 'fade',
      loop: true,
      modules: [EffectFade, Navigation],
      mousewheel: true,
      navigation: {
        nextEl: this.nextButton,
        prevEl: this.prevButton,
      },
      slidesPerView: 1,
      spaceBetween: 0,
    });
  }
}

const wheelCarousel = {
  init() {
    const wheelCarouselElements = document.querySelectorAll('[data-module="wheel-carousel"]');

    if (wheelCarouselElements && wheelCarouselElements.length) {
      wheelCarouselElements.forEach((element) => {
        const wheelCarouselElement = new WheelCarousel(element);
        wheelCarouselElement.init();
      });
    }
  },
};

export default wheelCarousel;
